import { render, staticRenderFns } from "./otomatikvirmanfisi.vue?vue&type=template&id=f21fc45c"
import script from "./otomatikvirmanfisi.vue?vue&type=script&lang=js"
export * from "./otomatikvirmanfisi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports